<template>
    <pageInfo>
        <template v-slot:content>
            <div class="order-info">
                <h3 class="name">评价订单</h3>
                <p class="desc">订单号：<span class="order-no">{{orderInfo.orderNum}}</span>{{orderInfo.createTime}}</p>
            </div>
            <div class="pin-info white-bg">
                <div class="pin-commit">
                    <div class="img-info">
                        <el-image class="img" :src="$common.imgPath(goodsInfo.goodsLog)" :alt="goodsInfo.goodsLog" lazy></el-image>
                        <p class="name">{{goodsInfo.goodsName}}</p>
                        <span class="price">¥{{$common.number(orderInfo.realPrice,2)}}</span>
                    </div>
                    <el-form class="rate-r" label-position="left" label-width="100px" :model="rateForm">
                        <el-form-item label="商品评分">
                            <el-rate class="mt10" v-model="rateForm.rate" @change="changeRate"></el-rate>
                        </el-form-item>
                        <el-form-item label="评价内容">
                            <el-input
                                    class="inp-pin"
                                    type="textarea"
                                    :autosize="{ minRows: 5, maxRows: 10}"
                                    placeholder="请输入内容"
                                    v-model="rateForm.content"
                                    resize="none"
                                    maxlength="500"
                                    show-word-limit>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <div>
                                <el-upload
                                        action="https://jsonplaceholder.typicode.com/posts/"
                                        list-type="picture-card"
                                        :limit="limitNum"
                                        :on-preview="handlePictureCardPreview"
                                        :on-remove="handleRemove">

                                    <i class="icon-add el-icon-circle-plus-outline"></i>
                                    <p class="add-tip">添加图片</p>
                                </el-upload>
                                <!--<p style="display: inline-block;">共 <span class="cell-red">0</span>张，还能上传 <span class="cell-red">9</span>张</p>-->
                                <el-dialog :visible.sync="dialogVisible">
                                    <img width="100%" :src="dialogImageUrl" alt="">
                                </el-dialog>
                            </div>

                            <button type="button" class="btn-main btn-small btn-apply" @click="submitAddEvaluate()">提交评价</button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </template>
    </pageInfo>

</template>
<script>
    import pageInfo from '../../layout/pageInfo/index.vue'
    import {addEvaluate} from '../../../api/goods'
    import {findOrderInfo} from '../../../api/order'
    export default {
        data(){
            return {
                userInfo:JSON.parse(localStorage.getItem('user'))||null,//登录用户信息
                orderInfo:'',
                goodsInfo:'',
                rateForm:{
                    rate:5,
                    content:'',
                    img:''
                },
                limitNum:9,
                dialogImageUrl: '',
                dialogVisible: false
            }
        },
        components:{
            pageInfo
        },
        computed:{
            orderId(){
                return this.$route.params.orderId;
            }
        },
        created () {


        },
        mounted(){
            this.findOrderInfo();
        },
        methods:{
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            changeRate(val){
                this.rateForm.rate=val;
            },
            findOrderInfo(){
                findOrderInfo({
                    userId:this.userInfo.userId,
                    orderId:this.orderId
                }).then((res)=>{
                    this.goodsInfo=res.data.goods;
                    this.orderInfo=res.data.order;
                })
            },
            submitAddEvaluate(){
                let params={
                    userId:this.userInfo.userId,
                    shopId:this.goodsInfo.shopId,
                    goodsId:this.goodsInfo.id,
                    orderId:this.orderId,
                    zongNum:this.rateForm.rate,
                    content:this.rateForm.content,
                    img:this.rateForm.img
                };
                console.log(params);
                addEvaluate(params).then(()=>{
                    this.$message({
                        message:'评论成功',
                        type:'info'
                    });
                    this.$router.back();
                })
            }


        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../assets/css/common";
    .order-info{
        padding:30px 0 20px;
        text-align: center;
        .name{font-size:16px;color:#333333;}
        .desc{
            padding-top:15px;
            font-size:12px;
            color:#999;
            .order-no{color:#333;padding-right:45px;}
        }

    }
    .pin-info{
        .pin-commit{
            overflow: hidden;
            .img-info{
                float: left;
                width:210px;
                padding:66px 56px;
                border-right:1px solid #EEEEEE;
                text-align: center;
                .img{width:120px;height:120px;background-color:$main-color;margin:0 auto;}
                .name{padding:20px 0 30px;line-height:18px;font-size:12px;
                    text-align: left;}
                .price{font-size:14px;
                    font-weight:700;
                    }
            }
            .rate-r{
                float: left;
                padding:66px 70px 0 44px;
                .inp-pin{
                    width:645px;
                }
                .apply-upload{
                    margin-top:20px;
                    width:100px;
                    height:78px;
                    background:rgba(244,244,244,1);
                    display: inline-block;

                }
                .btn-apply{
                    margin:40px 0 192px;
                    width:220px;
                    height:48px;
                    -webkit-border-radius: 4px;
                    -moz-border-radius: 4px;
                    border-radius: 4px;
                    font-size:18px;
                }
            }
        }

    }
</style>
<style lang="scss">
    @import "../../../assets/css/common";
    .el-upload--picture-card{
        width:100px;
        height:78px;
        padding:15px 0;
        background:rgba(244,244,244,1);
        border:none;
        line-height:20px;
        color:#333;
        &:hover{color:#333;}
        .add-tip{
            font-size:12px;
        }
    }
    .el-upload-list--picture-card .el-upload-list__item{width:100px;
        height:78px;}
</style>